declare global {
  interface Window {
    MathJax?: {
      tex?: object;
      startup?: {
        defaultReady: () => void;
        ready?: () => void;
      };
      typesetPromise?: (elements?: Element[]) => Promise<void>;
    };
  }
}

export const initializeMathJax = () => {
  if (typeof window !== "undefined" && !window.MathJax) {
    window.MathJax = {
      tex: {
        inlineMath: [["$", "$"]],
        displayMath: [["$$", "$$"]],
        processEscapes: true
      },
      startup: {
        defaultReady: () => {},
        ready: () => {
          window.MathJax?.startup?.defaultReady();
        }
      }
    };

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js";
    script.async = true;
    document.head.appendChild(script);
  }
};

export const processMathJax = (elements?: Element[]) => {
  setTimeout(() => {
    if (window.MathJax?.typesetPromise) {
      window.MathJax.typesetPromise(elements);
    }
  }, 100);
};
